// extracted by mini-css-extract-plugin
export default {"btnsWrap":"form-submit-wrapper_btnsWrap__CO3Ya"};